// import { useState } from "react";
// import "./Truncate.css";

// const ExpandableText = ({ text }) => {
//   const [isOpen, setIsOpen] = useState(false);

//   return (
//     <div className="wrapper_container">
//       <div
//         className={`question_text ${isOpen ? "is_open" : "is_collapsed"}`}
//         onClick={() => setIsOpen(!isOpen)}>
//         <p className="text_content">{text}</p>

//         {/* Индикатор для пользователя (опционально) */}
//         {!isOpen && <div className="expand_hint">...</div>}
//       </div>
//     </div>
//   );
// };

// export default ExpandableText;

// import { useState, useRef, useEffect } from "react";
// import "./Truncate.css";

// const ExpandableText = ({ text }) => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [isOverflowing, setIsOverflowing] = useState(false);
//   const contentRef = useRef(null); // Реф на сам текст (P), а не на контейнер

//   useEffect(() => {
//     const checkOverflow = () => {
//       if (contentRef.current) {
//         // scrollHeight вернет полную высоту контента,
//         // даже если родитель его обрезает до 60px
//         console.log(contentRef.current.scrollHeight);
//         const contentHeight = contentRef.current.scrollHeight;
//         setIsOverflowing(contentHeight >= 58);
//       }
//     };

//     checkOverflow();
//     window.addEventListener("resize", checkOverflow);
//     return () => window.removeEventListener("resize", checkOverflow);
//   }, [text]);

//   return (
//     <div className="wrapper_container">
//       <div
//         className={`question_text ${isOpen ? "is_open" : "is_collapsed"} ${isOverflowing ? "can_expand" : ""}`}
//         onClick={() => isOverflowing && setIsOpen(!isOpen)}>
//         {/* Реф вешаем на внутренний элемент, чтобы знать его реальную высоту */}
//         <p ref={contentRef} className="text_content">
//           {text}
//         </p>

//         {isOverflowing && !isOpen && (
//           <div className="expand_badge">Развернуть</div>
//         )}
//       </div>
//     </div>
//   );
// };

import { useState, useRef, useLayoutEffect } from "react";
import "./Truncate.css";
import { CloseOutlined } from "@mui/icons-material";

const ExpandableText = ({ text }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const containerRef = useRef(null);
  const contentRef = useRef(null);

  useLayoutEffect(() => {
    const checkOverflow = () => {
      if (containerRef.current && contentRef.current) {
        const el = contentRef.current;

        // 1. Замеряем высоту с включенным line-clamp (как оно сейчас на экране)
        const clampedHeight = el.getBoundingClientRect().height;

        // 2. Временно снимаем line-clamp
        const originalClamp = el.style.webkitLineClamp;
        const originalDisplay = el.style.display;

        el.style.webkitLineClamp = "none";
        el.style.display = "block";

        // 3. Замеряем высоту БЕЗ ограничений
        const fullHeight = el.scrollHeight;

        // 4. Возвращаем всё назад
        el.style.webkitLineClamp = originalClamp;
        el.style.display = originalDisplay;

        // 5. ЛОГИКА: Если полная высота больше, чем та, которую разрешил line-clamp
        // значит CSS обрезал текст.
        const hasOverflow = fullHeight > clampedHeight + 2;

        // console.log(
        //   "Высота с зажимом:",
        //   clampedHeight,
        //   "Полная высота:",
        //   fullHeight,
        // );
        setIsOverflowing(hasOverflow);
      }
    };

    // Отслеживаем и контейнер, и изменения в документе
    const observer = new ResizeObserver(() => {
      // Используем requestAnimationFrame, чтобы замер случился
      // ПОСЛЕ того, как браузер применил все стили медиа-запросов
      requestAnimationFrame(checkOverflow);
    });

    if (containerRef.current) observer.observe(containerRef.current);
    checkOverflow();

    return () => observer.disconnect();
  }, [text]);

  return (
    <div className="wrapper_container">
      <div
        ref={containerRef}
        className={`question_text ${isOpen ? "is_open" : "is_collapsed"}`}
        onClick={() => isOverflowing && setIsOpen(!isOpen)}>
        <p ref={contentRef} className="text_content">
          {text}
        </p>

        {isOverflowing && !isOpen && (
          <div className="expand_badge">Развернуть</div>
        )}
      </div>

      {/* Если текст открыт, создаем невидимую подложку для закрытия по клику вне */}
      {isOpen && (
        <div className="overlay_shroud" onClick={() => setIsOpen(false)} />
      )}
    </div>
  );
};
export default ExpandableText;
